<ol class="podium">
  @for (entry of entries().slice(0, 3); track entry.codeName; let index = $index) {
    <li class="podium__place" [class]="'podium__place podium__place--' + (index + 1)">
      <span class="podium__rank">{{ digits(entry.rank) }}</span>
      <img class="portrait portrait--small" src="/assets/silhouette.svg" alt="" />
      <p class="podium__name">{{ entry.codeName }}</p>
      <p class="first-name podium__first-name">{{ entry.firstName }}</p>
      <p class="podium__score">
        {{ entry.score }} {{ entry.score > 1 ? 'éliminations' : 'élimination' }}
      </p>
      @if (entry.statusCode === 'SUCCEEDED') {
        <p class="badge badge--gold">Vainqueur</p>
      }
      @if (entry.victims.length > 0) {
        <p class="podium__victims-label">Cibles éliminées</p>
        <ul class="podium__victims">
          @for (victim of entry.victims; track victim) {
            <li>{{ victim }}</li>
          }
        </ul>
      }
    </li>
  }
</ol>
